import { getInitials, getAMCLogoURL } from "creso-core/utils";
import { isProduction } from "../../utils";
import { Avatar } from "../avatars";

export function AmcLogo({
  amc_code: amcCode,
  size = "sm",
  className,
}: {
  amc_code: string | null;
  className?: string;
  size?: "xs" | "sm" | "lg" | "md" | "default";
}) {
  return (
    <Avatar
      className={className}
      url={getAMCLogoURL(amcCode, isProduction())}
      fallback={getInitials(amcCode || "")}
      size={size}
      variant="amc-logo"
    />
  );
}
